export const getSelectedFilterValues = (filter) => {
    const selectedOptionsByKey = {};
    Object.entries(filter.sections).forEach(([key, section]) => {
        selectedOptionsByKey[key] = section.options.filter(option => option.selected).map(option => option.value);
    });
    return selectedOptionsByKey;
};
